import React, { Component } from "react";
import {
  utcTimestamp,
  utcOffset,
  amOrPm,
  localTime,
  getHours,
  getMinutes
} from "../../utils/time";

export const withTimezone = WrappedCmp =>
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        changed: false,
        selectedTimezone: null
      };
    }

    getActiveTimezone() {
      const selectedTimezone = this.getSelectedTimezone();
      if (typeof selectedTimezone === "number") return selectedTimezone;
      return this.getCurrentTimezone();
    }

    getCurrentTimezone() {
      const { timezone } = this.props;
      return typeof timezone === "number" ? timezone : utcOffset();
    }

    getSelectedTimezone() {
      const { selectedTimezone } = this.state;
      return selectedTimezone;
    }

    getCurrentTimestamp() {
      const { timestamp } = this.props;
      return timestamp || utcTimestamp();
    }

    getLocalDate(timezone) {
      const timestamp = this.getCurrentTimestamp();
      return localTime(timestamp, timezone);
    }

    getCurrentDate() {
      const timezone = this.getCurrentTimezone();
      return this.getLocalDate(timezone);
    }

    getSelectedDate() {
      const timezone = this.getSelectedTimezone();
      return this.getLocalDate(timezone);
    }

    updateTimezone(selectedTimezone) {
      this.setState({ changed: true, selectedTimezone });
      if (typeof this.props.updateTimezone === "function")
        this.props.updateTimezone(selectedTimezone);
    }

    saveTimezone() {
      this.setState({ changed: false });
      if (typeof this.props.saveTimezone === "function")
        this.props.saveTimezone(this.getSelectedTimezone());
    }

    getFormattedDate(date) {
      return `${getHours(date)}:${getMinutes(date)}${amOrPm(date)}`;
    }

    render() {
      return (
        <WrappedCmp
          changed={this.state.changed}
          selectedTimezone={this.getSelectedTimezone()}
          timestamp={this.getCurrentTimestamp()}
          getActiveTimezone={this.getActiveTimezone.bind(this)}
          getCurrentTimezone={this.getCurrentTimezone.bind(this)}
          getCurrentTimestamp={this.getCurrentTimestamp.bind(this)}
          getCurrentDate={this.getCurrentDate.bind(this)}
          getSelectedDate={this.getSelectedDate.bind(this)}
          getFormattedDate={this.getFormattedDate.bind(this)}
          getLocalDate={this.getLocalDate.bind(this)}
          {...this.props}
          // Bubble up events to parent props
          updateTimezone={this.updateTimezone.bind(this)}
          saveTimezone={this.saveTimezone.bind(this)}
        />
      );
    }
  };



// WEBPACK FOOTER //
// ./src/components/Timezone/index.js